module.exports = __webpack_public_path__ + "img/icon_betadine.6b7f1140.png";